WiseMetering.Collection.RootObjects = WiseMetering.Collection.extend({
    comparator: 'order',
    build: function() {
        let models = [];
        WiseMetering.zones.sites().forEach(function(site, index) {
            models.push(site.rootObjects(index).models);
        });

        return new WiseMetering.Collection.RootObjects(models.flat());
    }
});
